<p-dialog [modal]="true"
          [visible]="visible"
          [dismissableMask]="true"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          [showHeader]="false"
          styleClass="add-area-dialog"
          contentStyleClass="add-area-dialog-content"
          [style]="{ 'border-radius': '8px 8px 0 0' }"
          (visibleChange)="onDrawerVisibleChange($event)"
          (onHide)="onCancel()">

  <form [formGroup]="form"
        novalidate>
    <div class="dialog-frame">
      <div class="dialog-header"
           data-testid="dialog-header">
        <div class="header-md-bold"
             data-testid="dialog-edit-room-header">
          Edit Room Names
        </div>
      </div>

      <div class="dialog-inputs">
        @for (zone of zones; track trackByZone($index, zone); let zoneIndex = $index) {
          @if (getRoomsForZone(zone.id).length > 0) {
            <section class="areas-container">
              <div class="body-md-bold zone-label"
                   [attr.data-testid]="'zone-label-' + zone.id">
                {{ zone.name }}
              </div>

              <div class="radiobuttons-container">
                @for (roomControl of getRoomsForZone(zone.id); track trackByRoom($index, roomControl); let roomIndex = $index) {
                  <div class="area-name-container">
                    <div class="area-name-input-container">
                      <div class="room-input-row">
                        <input pInputText
                               type="text"
                               class="area-name-input"
                               [formControl]="roomControl.controls.name"
                               [class.ng-invalid]="roomNameInvalid(roomControl)"
                               [class.ng-dirty]="roomControl.controls.name.touched"
                               [attr.id]="'room-name-input-' + roomControl.controls.id.value"
                               [attr.aria-describedby]="'current-room-name-' + roomControl.controls.id.value + ' room-name-validation-' + roomControl.controls.id.value"
                               [attr.data-testid]="'room-name-input-' + roomControl.controls.id.value"
                               [attr.tabindex]="getRoomTabIndex(zoneIndex, roomIndex)"
                               [attr.enterkeyhint]="isLastRoomInDialog(zone.id, roomIndex) ? 'go' : 'next'" />

                        @if (showClearButton(roomControl)) {
                          <button pButton
                                  severity="secondary"
                                  styleClass="bqa-secondary-btn"
                                  icon="pi pi-times-circle"
                                  class="clear-button"
                                  type="button"
                                  [text]="true"
                                  [rounded]="true"
                                  [attr.tabindex]="-1"
                                  [attr.aria-label]="'Clear room name for ' + roomControl.controls.currentName.value"
                                  [attr.data-testid]="'clear-room-name-' + roomControl.controls.id.value"
                                  (click)="clearName(roomControl)">
                          </button>
                        }
                      </div>

                      <small class="area-name-input-info"
                             [attr.id]="'current-room-name-' + roomControl.controls.id.value"
                             [attr.data-testid]="'current-room-name-' + roomControl.controls.id.value">
                        Current Name: {{ roomControl.controls.currentName.value }}
                      </small>

                      @if (roomNameInvalid(roomControl)) {
                        <app-input-error [attr.id]="'room-name-validation-' + roomControl.controls.id.value"
                                         [attr.data-testid]="'room-name-validation-' + roomControl.controls.id.value">
                          {{ roomNameErrorText(roomControl) }}
                        </app-input-error>
                      }
                    </div>
                  </div>
                }
              </div>
            </section>
          }
        }
      </div>

      <div class="dialog-buttons-container">
        <p-button class="dialog-button"
                  label="Cancel"
                  [outlined]="true"
                  data-testid="edit-room-names-cancel-button"
                  styleClass="bqa-primary-btn p-fullwidth-button"
                  severity="contrast"
                  [attr.tabindex]="getCancelTabIndex()"
                  (click)="onCancel()">
        </p-button>

        <p-button class="dialog-button"
                  label="Save All"
                  severity="primary"
                  styleClass="bqa-primary-btn p-fullwidth-button"
                  [disabled]="isSaving()"
                  [loading]="isSaving()"
                  data-testid="edit-room-names-save-button"
                  [attr.tabindex]="getSaveTabIndex()"
                  (click)="onSave()">
        </p-button>
      </div>
    </div>
  </form>
</p-dialog>